"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentTypeNameEnum;
(function (PaymentTypeNameEnum) {
    PaymentTypeNameEnum["CASH"] = "\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u043C\u0438";
    PaymentTypeNameEnum["CARD"] = "\u041A\u0430\u0440\u0442\u043E\u0439";
    PaymentTypeNameEnum["ONLINE"] = "\u041E\u043D\u043B\u0430\u0439\u043D";
    PaymentTypeNameEnum["CARD_ONLINE"] = "\u041A\u0430\u0440\u0442\u043E\u0439 \u043E\u043D\u043B\u0430\u0439\u043D";
    PaymentTypeNameEnum["GOOGLE_PAY"] = "Google Pay";
    PaymentTypeNameEnum["APPLE_PAY"] = "Apple Pay";
    PaymentTypeNameEnum["SAMSUNG_PAY"] = "Samsung Pay";
    PaymentTypeNameEnum["PIN_PAD"] = "PIN-pad";
})(PaymentTypeNameEnum = exports.PaymentTypeNameEnum || (exports.PaymentTypeNameEnum = {}));
//# sourceMappingURL=PaymentTypeNameEnum.js.map